<div class="info-banner" [ngClass]="'mat-' + color()">
  <div class="info-banner__title">
    <div class="info-banner__title-text" [class.icon-top]="iconAlign() === 'top'">
      @if (icon()) {
        <fa-icon [icon]="icon()"></fa-icon>
      }
      <ng-content select="[slot=title]"></ng-content>
    </div>
    <div class="info-banner__actions">
      <ng-content select="[slot=actions]"></ng-content>
    </div>
  </div>
</div>
